import { createSheetTabParam } from '@repo/ui/components/molecules/sheet-tabs';

/**
 * Schede del dettaglio (Previxio DS · sheet del ticket): Conversazione,
 * Dettagli, Cronologia. La scheda viaggia sull'URL (`?tab=`), così un link
 * o un reload riaprono la stessa scheda; senza parametro è la
 * Conversazione.
 */
export const TICKET_DETAIL_TABS = [
  'conversation',
  'details',
  'history',
] as const;

export type TicketDetailTab = (typeof TICKET_DETAIL_TABS)[number];

export const TICKET_DETAIL_DEFAULT_TAB: TicketDetailTab = 'conversation';

/** Il contratto della scheda nell'URL, letto da `useSheetTabSearch`. */
export const TICKET_DETAIL_TAB_PARAM = createSheetTabParam(
  TICKET_DETAIL_TABS,
  TICKET_DETAIL_DEFAULT_TAB
);

/** Il parametro della search che porta la scheda. */
export const TICKET_DETAIL_TAB_SEARCH_KEY = 'tab';

/** Parametri della search che appartengono al dettaglio, tolti tornando alla lista. */
export const TICKET_DETAIL_SEARCH_KEYS = [
  TICKET_DETAIL_TAB_SEARCH_KEY,
] as const;

/** La scheda da mostrare per il valore dell'URL (sconosciuto = Conversazione). */
export const resolveTicketDetailTab = TICKET_DETAIL_TAB_PARAM.resolve;

/**
 * Il valore da scrivere nell'URL per una scheda: la Conversazione, che è il
 * default, non lascia parametri.
 */
export const toTicketDetailTabParam = TICKET_DETAIL_TAB_PARAM.toParam;
